import { queryOptions } from '@tanstack/react-query';
import { getPolygon, type PolygonSearchParams } from '@/actions/polygons';

const RESOURCE = 'polygons' as const;

const polygons = {
  byAreaId: ({ areaIds, searchParams = {} }: { areaIds: number[]; searchParams?: PolygonSearchParams }) => {
    const sortedAreaIds = [...areaIds].sort((a, b) => a - b);
    return queryOptions({
      queryFn: () => getPolygon({ areaIds: sortedAreaIds, searchParams }),
      queryKey: [RESOURCE, 'byId', ...sortedAreaIds, { searchParams }] as const,
    });
  },
};

export { polygons };
